
export const setToken = (token) => {
  sessionStorage.setItem('token', token);
};
export const setUser = (user) => {
  sessionStorage.setItem('user', JSON.stringify(user));
};

export const getUser = () => {
  const u = sessionStorage.getItem('user');
  return u ? JSON.parse(u) : null;
};
export const getUserRole = () => {
  return getUser()?.role || 'guest';
};
